    import dayjs from "dayjs";
    export const MAX_BIRTH_DATE = dayjs().subtract(18, "year");
    export const MIN_DATE = dayjs("1900-01-01")